import axios from "axios";

export default {

    // list CustomCharacterImages
    listCustomCharacterImage(data) {
        return this.handelAlert((res, rej, loadObj) => {
            axios.get(`${base}/api/bookChapter/getImage?` + Object.QueryString({
                "chapter": "1",
                ...data
            }), {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("token") ? localStorage.getItem("token") : token}`
                }
            }).then(d => {
                let data = d.data.data || [];
                data = data.map(o => {
                    o.filePath = o.file.filePath;
                    return o;
                });
                res(d.data);
            }).catch(rej);
        }, true, `<span>Have fun making someone a special part of Ellie Belly's adventure!</span><br/><span>Just a moment...</span>`);
    },

    getCustomBookImages(data) {
        return this.handelAlert((res, rej, loadObj) => {
            axios.get(`${base}/api/bookChapter/allImages?` + Object.QueryString({
                ...data
            }), {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("token") ? localStorage.getItem("token") : token}`
                }
            }).then(d => {
                let data = d.data.data || [];
                data = data.map(o => {
                    o.filePath = o.file.filePath;
                    return o;
                });
                res(d.data);
            }).catch(rej);
        }, true, "<span>Our book elves are creating your preview!</span><br/><span>Please wait...</span>");
    },

    getCustomBookImagesWithContents(data) {
        return this.handelAlert((res, rej, loadObj) => {
            axios.get(`${base}/api/bookChapter/allImagesWithContent?` + Object.QueryString({
                ...data
            }), {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("token") ? localStorage.getItem("token") : token}`
                }
            }).then(d => {
                let data = d.data.data || [];
                data = data.map(o => {
                    o.filePath = o.file.filePath;
                    return o;
                });
                res(d.data);
            }).catch(rej);
        }, true, "<span>Our book elves are creating your preview!</span><br/><span>Please wait...</span>");
    },
}
